import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchShowProcess(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/reporting/${service_provider_id}/show_process/${delivery_process_id}`
    );
  },

  downloadXlsx(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/reporting/${service_provider_id}/show_process/${delivery_process_id}/download_xlsx`,
       { responseType: "blob" }
    );
  },

  downloadWeeklyXlsx(service_provider_id, delivery_process_id) {
    return RequesterV1.get(
      `service_provider/delivery/reporting/${service_provider_id}/show_process/${delivery_process_id}/download_weekly_xlsx`,
       { responseType: "blob" }
    );
  }
};
